/**
 * SFrame256 — Post-order notes (hearing dates, docket numbers).
 */

import { useParams, Link } from 'react-router-dom';
import ClosePhaseChrome from './ClosePhaseChrome';

export default function SFrame256() {
  const { estateId } = useParams<{ estateId: string }>();
  const suffix = estateId ? `/${estateId}` : '';

  return (
    <ClosePhaseChrome
      estateId={estateId}
      title="Court follow-up"
      subtitle="After you file, track hearing dates, docket numbers, and any supplemental orders. Upload the signed discharge on the prior screen so automated closure checks can pass."
    >
      <ol className="list-decimal list-inside text-sm text-slate-700 space-y-2 max-w-3xl">
        <li>Note the judge or magistrate assigned to the closing motion.</li>
        <li>Calendar any status conferences or prove-up hearings.</li>
        <li>Confirm when the order is entered and distribute certified copies to financial institutions.</li>
      </ol>
      <div className="flex flex-wrap gap-4 text-sm print:hidden">
        <Link to={`/sframe-255${suffix}`} className="text-blue-800 hover:underline">
          ← Discharge petition
        </Link>
        <Link to={`/sframe-257${suffix}`} className="font-medium text-blue-800 hover:underline">
          Close accounts →
        </Link>
      </div>
    </ClosePhaseChrome>
  );
}
